import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { RouterTitleService } from '../core/services/router-title.service';

@Component({
  selector: 'app-context-title',
  templateUrl: './context-title.component.html',
  styleUrls: ['./context-title.component.scss'],
  standalone: false,
})
export class ContextTitleComponent {
  readonly title$: Observable<string>;

  constructor(routerTitle: RouterTitleService) {
    this.title$ = routerTitle.title$;
  }
}
